
export const environment = {
  production: false,
  env: 'dev',
}
